import moment from 'moment';

const compareStartTimes = (a, b) => {
  const aa = moment(a.start_time).valueOf();
  const bb = moment(b.start_time).valueOf();

  return aa > bb ? 1 : aa < bb ? -1 : 0;
};

export default compareStartTimes;
